module.exports = __webpack_public_path__ + "img/mobile_map_assisi.fe3688ec.svg";